module.exports = __webpack_public_path__ + "static/media/Arial-Rounded-MT-Light.d6351428.svg";